module.exports = __webpack_public_path__ + "static/image/company/m/image_conduct_2@3x.jpg?c7c983b8";